"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessCRP_1 = require("./WirelessCRP");
exports.default = WirelessCRP_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCRP/index.js
// module id = 795
// module chunks = 8